$(document).ready(function () {
    // alert()
    // Ajax drawer js start
    var ajaxCartDrawer = {
      AjaxcartUpdateCartCount: function (cart) {
        var CartCount = $("#vetallies-ajax-cart")
          .find(".cart__products")
          .data("count");
        $(".count-style").html(CartCount);
        var price_without_money = $("#vetallies-ajax-cart")
          .find(".cart__products")
          .data("cart-total-price");
        var price_with_money = $("#vetallies-ajax-cart")
          .find(".cart__products")
          .data("cart-total-money");
        $(".cart-subtotal__price").html(price_with_money);
      },
      AjaxcartNoProduct: function (elements) {
        $("[data-cart-wrapper],#shopify-section-cart-faqs").addClass("hide");
        $("[data-empty-page-content]").removeClass("hide");
        $("body").removeClass("show-cart-loader");
      },
      AjaxcartRender: function () {
        $("body").addClass("show-cart-loader");
        $.ajax({
          url: "/cart?view=ajax",
          type: "get",
          async: false,
          success: function (cart) {
            $("#vetallies-ajax-cart").html(cart);
            ajaxCartDrawer.AjaxcartUpdateCartCount();
            $("body").removeClass("show-cart-loader");
          },
          error: function (e) {
            $("body").removeClass("show-cart-loader");
            ajaxCartDrawer.AjaxcartUpdateCartCount();
            alert(e.responseJSON.message);
          },
        });
      },
      AjaxcartChangeHandler: function (data) {
        $("body").addClass("show-cart-loader");
        $.ajax({
          url: "/cart/change.js",
          dataType: "json",
          cache: false,
          type: "post",
          data: data,
          async: true,
          success: function (cart) {
            console.log(cart);
            ajaxCartDrawer.AjaxcartRender();
            var CartCount = cart.item_count;
            $("[data-cart-count]").html(CartCount);
            $(".cart-popup__heading span").text(CartCount);
            if (!CartCount) {
              ajaxCartDrawer.AjaxcartNoProduct();
            }
          },
          error: function (e) {
            $("body").removeClass("show-cart-loader");
            alert(e.responseJSON.message);
            window.location.href = "/cart";
          },
        });
      },
      AjaxcartQuantityHandler: function () {
        $(document).on("change", ".pro-dec-cart input", function () {
          
          var UpdatedQuantity = parseInt($(this).val()),
            QuantityLine = parseInt($(this).attr("data-line")),
            params = {
              quantity: UpdatedQuantity,
              line: QuantityLine,
            };
          ajaxCartDrawer.AjaxcartChangeHandler(params);
        });
        $(document).on("click", ".product-remove", function (e) {
          e.preventDefault();
          var product_type = $(this).closest(".cart__row").data("cart-item-type");
          if (product_type == "free-gift") {
            $("#checkout-discount").val("");
            sessionStorage.setItem("Free product remvoed", true);
          }
          var RemoveLine = parseInt($(this).attr("data-line")),
            params = {
              quantity: 0,
              line: RemoveLine,
            };
          ajaxCartDrawer.AjaxcartChangeHandler(params);
        });
      },
      AjaxcartAddAppraisal: function () {
        $(document).on("click", ".cart__add-appraisal .btn", function (e) {
          e.preventDefault();
          var max_limit = $(".cart__products").data("appraisal-limit");
          var appraisalProduct = {
            id: 45178235617563,
            quantity: 1,
          };
          $("body").addClass("show-cart-loader");
          $("html, body").animate({ scrollTop: "0" });
          try {
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: appraisalProduct,
              dataType: "json",
              async: true,
              success: function () {
                // window.location.href = "/cart";
                ajaxCartDrawer.AjaxcartRender();
              },
              error: function (XMLHttpRequest, textStatus, errorThrown) {
                console.log(XMLHttpRequest, textStatus, errorThrown);
              },
            });
          } catch (e) {
            console.loe(e);
          }
        });
        $(document).on(
          "click",
          ".free-gift-wrapper .primary-button",
          function (e) {
            e.preventDefault();
            var varaintId = $(this).data("variant-id");
            var appraisalProduct = {
              quantity: 1,
            };
            appraisalProduct["id"] = varaintId;
            $("body").addClass("show-cart-loader");
            try {
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: appraisalProduct,
                dataType: "json",
                async: true,
                success: function () {
                  ajaxCartDrawer.AjaxcartRender();
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                  console.log(XMLHttpRequest, textStatus, errorThrown);
                },
              });
            } catch (e) {
              console.loe(e);
            }
          }
        );
        // appraisal popup button
        $(document).on(
          "click",
          ".cart__add-appraisal .appraisal-title",
          function () {
            $("body").addClass("show-website-popup");
            $("#cart-appraisal-popup").addClass("show-popup-content");
          }
        );
        // clear diamond availability cookies
        $(".cart__submit-controls [type='submit']").on("click", function () {
          localStorage.removeItem("diamond-pdp-obj");
          sessionStorage.removeItem("unavailable_diamond");
          sessionStorage.removeItem("diamond-checklist");
        });
      },
    };
    $("body").addClass("show-cart-loader");
    ajaxCartDrawer.AjaxcartRender();
    ajaxCartDrawer.AjaxcartQuantityHandler();
    ajaxCartDrawer.AjaxcartAddAppraisal();
  });
  